<script>
import { Bar, HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  props: {
    chartData: Object,
    labels: Array,
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  extends: Bar,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return tooltipItem[0].label;
            },
            label: function (tooltipItem, data) {
              return tooltipItem.value + "% average emotion";
            },
            labelTextColor: (tooltipItem, chart) => {
              return this.chartData.datasets[tooltipItem.datasetIndex]
                .backgroundColor;
            },
          },
          backgroundColor: "#FFF",
          titleFontSize: 16,
          titleFontColor: "#141a77",
          footerFontColor: "#000",
          bodyFontSize: 14,
          labelAlign: "center",
          displayColors: false,
        },
        onClick: (mouseEvent, chart) => {
          if (this.$data._chart.tooltip._lastActive[0]) {
            const activeIndex = this.$data._chart.tooltip._lastActive[0]._index;
            const page = this.$data._chart.data.labels[activeIndex];
            const id = this.labels.find((i) => i.name === page).id;
            if (page) {
              const route = this.$router.push({
                path: `/test/${this.$route.params.id}/page-insights?page=${id}`,
              });
            }
          }
        },
        hover: { mode: null },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                min: 10,
                max: 90,
                padding: 20,
              },
              gridLines: {
                zeroLineColor: "transparent",
                borderDash: [3, 10],
                borderWidth: 3,
                drawBorder: false,
                color: "rgba(132, 134, 158, 1)",
              },
            },
          ],
          xAxes: [
            {
              stacked: this.stacked,
              ticks: {
                fontColor: "#141a77",
              },
              gridLines: {
                borderDash: [5, 10],
                drawBorder: false,
                color: "rgba(132, 134, 158, 1)",
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
